import { type ReactNode } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LoginPage } from "./pages/LoginPage";
import { SignupPage } from "./pages/SignupPage";
import { AcceptInvitePage } from "./pages/AcceptInvitePage";
import { RecipesIndexPage } from "./pages/RecipesIndexPage";
import { RecipeDetailPage } from "./pages/RecipeDetailPage";
import { RecipeEditPage } from "./pages/RecipeEditPage";
import { InvitePage } from "./pages/InvitePage";
import { PlanPage } from "./pages/PlanPage";
import { RegularsPage } from "./pages/RegularsPage";
import { ShoppingListPage } from "./pages/ShoppingListPage";
import { BasketPlanPage } from "./pages/BasketPlanPage";

function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const { me, isLoading } = useAuth();
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <span className="label animate-fade-in text-ink-muted">one moment</span>
      </div>
    );
  }
  if (me) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/login"
          element={
            <RedirectIfAuthed>
              <LoginPage />
            </RedirectIfAuthed>
          }
        />
        <Route
          path="/signup"
          element={
            <RedirectIfAuthed>
              <SignupPage />
            </RedirectIfAuthed>
          }
        />
        <Route path="/accept-invite" element={<AcceptInvitePage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <RecipesIndexPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/recipes/new"
          element={
            <ProtectedRoute>
              <RecipeEditPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/recipes/:id"
          element={
            <ProtectedRoute>
              <RecipeDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/recipes/:id/edit"
          element={
            <ProtectedRoute>
              <RecipeEditPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invite"
          element={
            <ProtectedRoute>
              <InvitePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/plan"
          element={
            <ProtectedRoute>
              <PlanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/plan/:week_start"
          element={
            <ProtectedRoute>
              <PlanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/regulars"
          element={
            <ProtectedRoute>
              <RegularsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/shopping-list"
          element={
            <ProtectedRoute>
              <ShoppingListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/shopping-list/:week_start"
          element={
            <ProtectedRoute>
              <ShoppingListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/basket-plan"
          element={
            <ProtectedRoute>
              <BasketPlanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/basket-plan/:week_start"
          element={
            <ProtectedRoute>
              <BasketPlanPage />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
